import React from "react";
import "./terms.css";

// Updated import to use your existing project logo
import logo from "../../assets/images/RedP_LogoT.png";

const TermsAndConditions = () => {
  return (
    <div className="terms-page-container">
      <div className="split-view-card">
        {/* --- LEFT PANEL: Navigation & Metadata --- */}
        <div className="info-section">
          <div className="sticky-content">
            {/* Logo Image */}
            <img src={logo} alt="RedP Logo" className="sidebar-logo" />

            <h2>Terms of Service</h2>

            <div className="meta-block">
              <p>
                <strong>Version:</strong> 1.0
              </p>
              <p>
                <strong>Effective Date:</strong> April 10, 2025
              </p>
            </div>

            {/* Navigation Links */}
            <div className="nav-links-container">
              <a href="https://www.waterviewai.com" className="nav-link">
                <span>←</span> Back to Sign In
              </a>

              <a
                href="https://www.waterviewai.com/#/privacy-policy"
                className="nav-link"
              >
                Privacy Policy <span>→</span>
              </a>
            </div>
          </div>
        </div>

        {/* --- RIGHT PANEL: Full Document --- */}
        <div className="document-section">
          <div className="document-header">
            <h1>RedP Terms & Conditions</h1>
            <div className="subtitle">Real Estate Document Processor</div>
          </div>

          <div className="legal-content">
            <p>
              Welcome to RedP, a real estate document processor developed by
              WaterviewAI. By accessing and using RedP, you agree to be
              bound by the following Terms and Conditions. If you do not agree,
              please do not use this service.
            </p>

            <h4>1. Software Acknowledgment</h4>
            <p>
              RedP is an automated document processing tool. By using RedP, you
              acknowledge:
            </p>
            <ul>
              <li>
                RedP is provided “as is” and without warranties of any kind.
              </li>
              <li>
                The accuracy, completeness, or reliability of generated output
                cannot be guaranteed.
              </li>
              <li>
                You are responsible for proofreading all output and ensuring its
                appropriateness for your intended use.
              </li>
            </ul>

            <h4>2. User Responsibilities</h4>
            <p>As a RedP user, you agree to:</p>
            <ul>
              <li>Provide accurate and current registration information.</li>
              <li>Keep your login credentials confidential.</li>
              <li>
                Use RedP only for lawful purposes and in compliance with
                applicable regulations.
              </li>
            </ul>

            <h4>3. Feedback & Participation</h4>
            <p>
              We welcome and encourage your feedback to help improve RedP. By
              submitting feedback (via email, form, or other methods), you agree
              that:
            </p>
            <ul>
              <li>
                Your feedback may be used by WaterviewAI for any purpose,
                including improving the product.
              </li>
              <li>
                You do not retain any rights to suggestions, improvements, or
                changes arising from your feedback.
              </li>
            </ul>

            <h4>4. Data Retention and Privacy</h4>
            <p>RedP is designed to minimize data retention:</p>
            <ul>
              <li>
                We store only your first name, last name, email, password, and
                any custom output preferences you configure.
              </li>
              <li>
                Uploaded documents and extracted data are processed in-session
                only and not retained after your session ends.
              </li>
              <li>
                No documents or processed content will be stored or accessed
                outside your active session.
              </li>
            </ul>
            <p>For more information, please review our Privacy Policy.</p>

            <h4>5. Availability</h4>
            <p>
              We work to keep RedP available, but cannot guarantee uninterrupted
              uptime. You acknowledge that:
            </p>
            <ul>
              <li>
                There may be downtime, interruptions, or unexpected outages.
              </li>
              <li>
                You are using RedP at your own risk and should not rely on it
                as your only review step for critical or time-sensitive tasks.
              </li>
            </ul>

            <h4>6. Termination of Access</h4>
            <p>
              We reserve the right to suspend or terminate your access to RedP
              at any time, with or without notice, for any reason including
              abuse, misuse, or violation of these terms.
            </p>

            <h4>7. Limitation of Liability</h4>
            <p>
              To the fullest extent permitted by law, WaterviewAI and its
              affiliates, employees, or agents shall not be liable for:
            </p>
            <ul>
              <li>
                Any direct, indirect, incidental, or consequential damages
                resulting from your use of or inability to use RedP.
              </li>
              <li>
                Errors or omissions in content generated by RedP.
              </li>
            </ul>

            <h4>8. Changes to These Terms</h4>
            <p>
              We may update these Terms and Conditions from time to time. You
              will be notified of any material changes via email or through the
              application interface. Continued use of RedP constitutes
              acceptance of the updated terms.
            </p>

            <h4>9. Contact Us</h4>
            <p>Have questions or feedback?</p>
            <p>
              Email:{" "}
              <a
                href="mailto:RedP@WaterviewAI.com"
                style={{ color: "inherit", textDecoration: "underline" }}
              >
                RedP@WaterviewAI.com
              </a>
            </p>
            <p>
              Thank you for helping us improve RedP.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
